var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-card card-dashboard"},[_c('h1',[_vm._v(_vm._s(_vm.slide.title))]),(_vm.isVisible)?_c('DashboardTrack',{attrs:{"focus":_vm.getDialFocus},on:{"swiperUpdate":_vm.swiperUpdate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }